import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Bot, Zap } from 'lucide-react';

/**
 * Chat header component with Kari AI avatar
 */
const ChatHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 sticky top-0 z-10">
      <div className="max-w-4xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="p-2 hover:bg-gray-100 rounded-xl transition-all"
            >
              <ArrowLeft className="w-5 h-5 text-gray-600" />
            </button>
            
            <div className="flex items-center gap-3">
              <div className="relative">
                <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-xl flex items-center justify-center shadow-sm">
                  <Bot className="w-7 h-7 text-white" />
                </div>
                <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 border-2 border-white rounded-full"></div>
              </div>
              
              <div>
                <div className="font-bold text-gray-900 flex items-center gap-2">
                  Kari
                  <span className="px-2 py-0.5 bg-gray-100 text-gray-800 text-xs font-bold rounded-full">
                    AI
                  </span>
                </div>
                <div className="text-xs text-gray-600 flex items-center gap-1">
                  <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                  Aktiv nå
                </div>
              </div>
            </div>
          </div>

          <div className="hidden sm:flex items-center gap-2 text-xs text-gray-500">
            <Zap className="w-4 h-4" />
            AI-drevet juridisk veiledning
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
